export default __webpack_public_path__ + "static/media/speed-test-min.68f82484.jpg";